import { PocBadge } from 'commons/components/components-wrapper';
import { useId } from 'commons/hooks/use-id/use-id.hook';
import { AlarmAlert } from 'commons/icons/SmallAlarmAlert';
import { AlarmWarning } from 'commons/icons/SmallAlarmWarning';
import { SideMenuAlarm } from 'core/service/user-preferences/domain/model/side-menu-alarm.model';
import { useTranslation } from 'core/i18n/i18n';
import { TwoLevelTooltip } from './alarms-badge.style';

export type AlarmBadgeTypes = 'OPERATORS' | 'DEVICES';

export interface AlarmsBadgeComponentProps {
    alarms: SideMenuAlarm;
    size?: 'small' | 'medium';
    type?: AlarmBadgeTypes;
    showBadge?: boolean;
}

export const AlarmsBadgeComponent: React.FC<AlarmsBadgeComponentProps> = ({
    alarms,
    size = 'medium',
    type = 'OPERATORS',
    showBadge = true,
}) => {
    const { t } = useTranslation();
    const tooltipAnchorId = useId();
    const translations: Record<AlarmBadgeTypes, { warning: string; error: string }> = {
        OPERATORS: {
            warning: 'app.sidemenu.options.operators.alarms.due_soon',
            error: 'app.sidemenu.options.operators.alarms.missed_stage',
        },
        DEVICES: {
            warning: 'app.sidemenu.options.devices.alarms.warning',
            error: 'app.sidemenu.options.devices.alarms.error',
        },
    };

    return showBadge && alarms?.totalAlarm > 0 ? (
        <>
            <PocBadge
                id={tooltipAnchorId}
                data-testid={`${tooltipAnchorId}-alarms-badge`}
                status={alarms.ERROR ? 'alarm' : 'warning'}
                size={size}
            >
                {alarms.totalAlarm}
            </PocBadge>

            <TwoLevelTooltip
                data-testid={`${tooltipAnchorId}-alarms-tooltip`}
                anchor={tooltipAnchorId}
                strategy="fixed"
                placement="right"
            >
                <span slot="title">
                    {alarms.ERROR ? (
                        <>
                            <AlarmAlert />
                            {t(translations[type]?.error, {
                                number: alarms.ERROR,
                            })}
                        </>
                    ) : undefined}
                </span>

                <span>
                    {alarms.WARNING ? (
                        <>
                            <AlarmWarning />
                            {t(translations[type]?.warning, {
                                number: alarms.WARNING,
                            })}
                        </>
                    ) : undefined}
                </span>
            </TwoLevelTooltip>
        </>
    ) : undefined;
};
